<div class="counter">
    <span class="count">{{count}}</span>
    <span class="text">{{text}}</span>
</div>
